import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* Import dependencies for app.js */
import React, { Component, Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import sniffer from 'sniffer';
import { getGuardianStudents } from 'actions/guardians';
import { setActiveStudent, setActiveSchool, setActiveUser, setRefreshInProgress, setAuthenticated, setHaldorAppOrientation } from 'actions/user';
import { getMenuItems } from 'actions/menu';
import { getStatus } from 'actions';
import { getActiveStudent } from 'helpers/guardian';
import swal from 'sweetalert2';
import Menu from 'components/Menu';
import Header from 'components/HeaderV2';
import DeviceHeader from 'components/HeaderV2/Device';
import DesktopHeader from 'components/HeaderV2/Desktop';
import Footer from 'components/Footer/Footer';
import Error from './Error';
import { appInsights } from 'lib/appInsight';
import { Spinner } from 'UI';
import { Layout, Content, Sider, translate } from '@haldor/ui';
import { IsApp, AppPlatform } from '../helpers/deviceInfo';
import auth from 'lib/authentication';
import { getProfileInformation, putProfileInformation } from 'actions/profile';
import { setActiveLanguage, getActiveLanguage } from '@haldor/ui';
import { postRegisterPush } from 'actions/notifications';
import jwt_decode from "jwt-decode";
import '../assets/css/main.scss';
var App = /*#__PURE__*/function (_Component) {
  function App(props) {
    var _this;
    _classCallCheck(this, App);
    _this = _callSuper(this, App, [props]);
    _this.state = {
      token: '',
      loading: true,
      isActive: true
    };
    return _this;
  }
  _inherits(App, _Component);
  return _createClass(App, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;
        var token, user, justLoggedIn, waitForProfile, profile;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return auth.getAccessToken();
            case 1:
              token = _context2.sent;
              if (!(token != null)) {
                _context2.next = 2;
                break;
              }
              user = jwt_decode(token);
              window.addEventListener('message', function (event) {
                appInsights.trackTrace({
                  message: "App.js: Message recieved from react native"
                });
                if (event != null && event.data != null && event.data.type == "register_push") {
                  appInsights.trackTrace({
                    message: "App.js: Message with register push has received"
                  });
                  _this2.props.postRegisterPush(event.data);
                }
                if (event != null && event.data != null && event.data.type != null && event.data.type == "APP_DIMENSIONS") {
                  var _event$data;
                  appInsights.trackTrace({
                    message: "App.js: Message with APP_DIMENSIONS has received"
                  });
                  _this2.props.setHaldorAppOrientation((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.value);
                }
              });
              if (window.ReactNativeWebView != null) {
                // Wait 2 seconds to make sure react native is fully loaded the page
                setTimeout(function () {
                  appInsights.trackTrace({
                    message: "App.js: Notify app to register push"
                  });

                  // Access_token is needed for old react native version, just keeping this here to avoid problem with back compabiliy
                  window.ReactNativeWebView.postMessage(JSON.stringify({
                    register_push: true,
                    access_token: token
                  }));
                }, 2000);
              }
              appInsights.trackTrace({
                message: "App.js: Response from getUser method"
              });
              if (user != null) {
                appInsights.trackTrace({
                  message: "App.js: User information was found"
                });
                this.props.setActiveUser({
                  id: user.sub
                });
                if (appInsights != null) {
                  appInsights.context.user.id = user.sub;
                  appInsights.setAuthenticatedUserContext(user.sub, "", true);
                  appInsights.trackTrace({
                    message: 'App.js: User Logged in'
                  });
                }
              }
              _context2.next = 3;
              break;
            case 2:
              this.props.history.push("/login");
              return _context2.abrupt("return");
            case 3:
              if (this.props.students == null || this.props.students.length == 0) {
                appInsights.trackTrace({
                  message: 'App.js: Students information was not found, trying to fetch information from DB'
                });
                this.props.getGuardianStudents().then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var _t;
                  return _regeneratorRuntime.wrap(function (_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _t = _this2.props.students == null || _this2.props.students.length == 0;
                        if (_t) {
                          _context.next = 2;
                          break;
                        }
                        _context.next = 1;
                        return _this2.setStudent();
                      case 1:
                        _t = !_context.sent;
                      case 2:
                        if (!_t) {
                          _context.next = 3;
                          break;
                        }
                        swal({
                          title: _this2.props.translate('No active students'),
                          text: _this2.props.translate('You don´t have any active students connected to your account. If that´s incorrect, please contact your school'),
                          confirmButtonText: _this2.props.translate('ok')
                        }).then(function (result) {
                          //TODO SIGN OUT
                          _this2.props.history.push("/logout");
                        });
                        _context.next = 4;
                        break;
                      case 3:
                        _this2.props.getProfileInformation().then(function () {
                          if (_this2.props.profile != null && _this2.props.profile.lcid) {
                            if (getActiveLanguage() != _this2.props.profile.lcid) {
                              setActiveLanguage(_this2.props.profile.lcid);
                            }
                          } else {
                            setActiveLanguage('en-US');
                          }
                        });
                        _this2.setState({
                          loading: false
                        });
                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                })))["catch"](function (status) {
                  if (status > 400) {
                    //TODO: logout
                    _this2.props.history.push("/logout");
                  }
                });
              } else {
                appInsights.trackTrace({
                  message: 'App.js: trying to get profileInformation'
                });
                this.props.getProfileInformation().then(function () {
                  appInsights.trackTrace({
                    message: 'App.js: trying to get profileInformation'
                  });
                  if (_this2.props.profile != null && _this2.props.profile.lcid) {
                    if (getActiveLanguage() != _this2.props.profile.lcid) {
                      setActiveLanguage(_this2.props.profile.lcid);
                    }
                  } else {
                    setActiveLanguage('en-US');
                  }
                  _this2.setState({
                    loading: false
                  });
                });
              }
              this.props.getStatus(getActiveLanguage())["catch"](function (status) {
                if (status > 400) {
                  //TODO: logout
                }
              });
              justLoggedIn = sessionStorage.getItem("justLoggedIn") === "true";
              if (!justLoggedIn) {
                _context2.next = 7;
                break;
              }
              waitForProfile = function waitForProfile() {
                return new Promise(function (resolve) {
                  var _check = function check() {
                    var profile = _this2.props.profile;
                    if (profile) {
                      resolve(profile);
                    } else {
                      setTimeout(_check, 50);
                    }
                  };
                  _check();
                });
              };
              _context2.next = 4;
              return waitForProfile();
            case 4:
              profile = _context2.sent;
              if (!(user.lcid != profile.lcid)) {
                _context2.next = 6;
                break;
              }
              profile.lcid = user.lcid;
              _context2.next = 5;
              return this.props.putProfileInformation(profile);
            case 5:
              setActiveLanguage(profile.lcid);
            case 6:
              sessionStorage.removeItem("justLoggedIn");
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "setStudent",
    value: function () {
      var _setStudent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var active, student, tmpStudents, _i, _tmpStudents, _student, _t2;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // Try to set the active student
              active = getActiveStudent();
              if (!(active != null)) {
                _context3.next = 3;
                break;
              }
              student = this.props.students.find(function (student) {
                return student.id == active;
              });
              _t2 = student != null;
              if (!_t2) {
                _context3.next = 2;
                break;
              }
              _context3.next = 1;
              return this.enableStudent(student);
            case 1:
              _t2 = _context3.sent;
            case 2:
              if (!_t2) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return", true);
            case 3:
              // Try all other students until an active student is found
              tmpStudents = [];
              Object.assign(tmpStudents, this.props.students);
              _i = 0, _tmpStudents = tmpStudents;
            case 4:
              if (!(_i < _tmpStudents.length)) {
                _context3.next = 7;
                break;
              }
              _student = _tmpStudents[_i];
              _context3.next = 5;
              return this.enableStudent(_student);
            case 5:
              if (!_context3.sent) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return", true);
            case 6:
              _i++;
              _context3.next = 4;
              break;
            case 7:
              return _context3.abrupt("return", false);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function setStudent() {
        return _setStudent.apply(this, arguments);
      }
      return setStudent;
    }()
  }, {
    key: "enableStudent",
    value: function () {
      var _enableStudent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(student) {
        var index;
        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return this.props.setActiveStudent(student)["catch"](function (e) {});
            case 1:
              if (_context4.sent) {
                _context4.next = 2;
                break;
              }
              index = this.props.students.indexOf(student);
              if (index > -1) {
                this.props.students.splice(index, 1); // Remove student
              }
              return _context4.abrupt("return", false);
            case 2:
              _context4.next = 3;
              return this.props.getMenuItems(student.id);
            case 3:
              return _context4.abrupt("return", true);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function enableStudent(_x) {
        return _enableStudent.apply(this, arguments);
      }
      return enableStudent;
    }()
  }, {
    key: "render",
    value: function render() {
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
      var translate = this.props.translate;
      if (this.props.students == null || this.props.students.length == 0) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "login-content"
        }, /*#__PURE__*/React.createElement("h1", null, translate('Something went wrong')), /*#__PURE__*/React.createElement("p", {
          className: "login-content__subtitle"
        }, translate('It seems like you dont have any students assigned to your account'), /*#__PURE__*/React.createElement("br", null), translate('If you think something is wrong, get in touch with your school administrator or support@haldor.se (support.haldor.se)'))), /*#__PURE__*/React.createElement(Footer, null));
      }
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Error, null), !sniffer.isDevice ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "desktop-header-spacing"
      }), /*#__PURE__*/React.createElement(DesktopHeader, null)) : null, /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Sider, null, !sniffer.isDevice ? /*#__PURE__*/React.createElement(Menu, null) : null), /*#__PURE__*/React.createElement(Content, null, IsApp || sniffer.isDevice ? /*#__PURE__*/React.createElement("div", {
        className: "device-menu-space"
      }) : null, IsApp && AppPlatform === 'ios' ? /*#__PURE__*/React.createElement("div", {
        className: "device-menu-placeholder-iphone"
      }) : null, sniffer.isDevice && AppPlatform !== 'ios' ? /*#__PURE__*/React.createElement("div", {
        className: "device-menu-placeholder"
      }) : null, sniffer.isDevice ? /*#__PURE__*/React.createElement(DeviceHeader, null) : /*#__PURE__*/React.createElement(Header, null), sniffer.isDevice ? /*#__PURE__*/React.createElement("div", {
        className: "main"
      }, this.props.children) : this.props.children, /*#__PURE__*/React.createElement(Footer, null))));
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    students: state.guardians.students,
    activeStudent: state.User.activeStudent,
    profile: state.profile.profile,
    translate: translate(state.Languages.translations)
  };
};
export default withRouter(connect(mapStateToProps, {
  getGuardianStudents: getGuardianStudents,
  getStatus: getStatus,
  setActiveStudent: setActiveStudent,
  setActiveSchool: setActiveSchool,
  setActiveUser: setActiveUser,
  setAuthenticated: setAuthenticated,
  setRefreshInProgress: setRefreshInProgress,
  getMenuItems: getMenuItems,
  postRegisterPush: postRegisterPush,
  getProfileInformation: getProfileInformation,
  putProfileInformation: putProfileInformation,
  setHaldorAppOrientation: setHaldorAppOrientation
})(App));